import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useMemo,
} from "react";

export const MenuContext = ({ children }: React.PropsWithChildren) => {
  const value = useInitContext();
  return <Context value={value}>{children}</Context>;
};

export const useMenuContext = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error("MenuContext not found");
  }

  return context;
};

const Context = createContext<ReturnType<typeof useInitContext> | undefined>(
  undefined
);

function useInitContext() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const itemsRef = useRef<Array<HTMLElement | null>>([]);

  return useMemo(
    () => ({
      activeIndex,
      itemsRef,
      setActiveIndex,
    }),
    [activeIndex, itemsRef]
  );
}
